require('normalize.css');
require('../../assets/css/main.scss');
require('./index.scss');

import btdLogo from './images/bornthisday.svg';
import lendoLogo from './images/lendo.svg';
import compricerLogo from './images/compricer.svg';
import roiLogo from './images/roi.svg';
import faLogo from './images/framgangsakademin.svg';
import agencyAcademyLogo from './images/agency-academy.png';
import enigioLogo from './images/enigio.svg';
import mybankerLogo from './images/mybanker.svg';
import perspetivoLogo from './images/perspetivo.png';

document.getElementById('bornThisDayLogo').src = btdLogo;
document.getElementById('lendoLogo').src = lendoLogo;
document.getElementById('compricerLogo').src = compricerLogo;
document.getElementById('roiSwedenLogo').src = roiLogo;
document.getElementById('framgangsakademinLogo').src = faLogo;
document.getElementById('agencyAcademyLogo').src = agencyAcademyLogo;
document.getElementById('enigioLogo').src = enigioLogo;
document.getElementById('mybankerLogo').src = mybankerLogo;
document.getElementById('perspetivoLogo').src = perspetivoLogo;
